import Home01 from './Home01';


const routes = [
    { path: "/", component: Home01},
    
]

export default routes;